<template>
  <div>
    <cx-check-box :value.sync="showXAxis">显示横轴</cx-check-box>
    <div v-if="showXAxis && checkType(showXAxis)">
      <div v-if="chartOpt.xAxis && chartOpt.xAxis.type === 'value'">
        <div class="mt16">
          <span class="font14 mr16 inlineMiddle">纵轴段数</span>
          <el-radio-group v-model="hasSplitNumber" @change="typeChange">
            <el-radio value="auto" label="auto">自动</el-radio>
            <el-radio value="self" label="self">自定义</el-radio>
          </el-radio-group>
        </div>
        <div v-if="hasSplitNumber === 'self'">
          <slider-and-input
              class="mt12"
              :value.sync="splitNumber"
              title=""
              :sliderMax="100"
              :sliderMin="1"
              inputWidth="large"
              inputHeight="small"
              suffix="段"
              titlePosition="singleLine"
          />
        </div>
        <div class="mt16">
          <span class="font14 mr16 inlineMiddle">纵轴数值</span>
          <el-radio-group v-model="hasMaxMin" @change="typeChangeMaxMin">
            <el-radio value="auto" label="auto">平均值</el-radio>
            <el-radio value="self" label="self">自定义</el-radio>
          </el-radio-group>
        </div>
        <div v-if="hasMaxMin === 'self'">
          <slider-and-input
              class="mt12"
              :value.sync="min"
              title="最小值"
              :sliderMax="10000"
              :sliderMin="0"
              suffix=""
          />
          <slider-and-input
              class="mt12"
              :value.sync="max"
              title="最大值"
              :sliderMax="1000000"
              :sliderMin="1"
              suffix=""
          />
        </div>
      </div>
      <cx-check-box class="mt16" :value.sync="boundaryGap">原点不与刻度线重合</cx-check-box>
      <p class="font14 mb16 mt16">横轴文字</p>
      <div v-if="barColorType === 'single'">
        <text-setting-update
          colorMode="chart"
          :fontColor.sync="xAxisFontColor"
          :fontFamily.sync="xAxisFontFamily"
          :fontSize.sync="xAxisFontSize"
          :fontWeight.sync="xAxisFontWeight"
        />
        <slider-and-input
          class="mt16"
          v-if="checkType(xAxisLabelInterval) && xAxisData.length"
          :value.sync="xAxisLabelInterval"
          title="轴文字间距"
          :sliderMin="0"
          :sliderMax="60"
          suffix="位"
        />
        <!--轴线文本旋转-->
        <slider-and-input
          class="mt16"
          v-if="checkType(xAxisLabelRotate)"
          :value.sync="xAxisLabelRotate"
          title="旋转"
          :sliderMax="sliderMax"
          suffix="度"
        />
      </div>

      <div class="mt16" v-if="checkType(showXAxisUnit)">
        <cx-check-box :value.sync="showXAxisUnit">显示单位</cx-check-box>
        <div class="mt16" v-if="showXAxisUnit">
          <span class="font14 mr10 half-label">单位文本</span>
          <el-input
            class="width-half-bigWidth el-input el-input--suffix"
            placeholder="请输入"
            v-model="showXAxisUnitValue"
          >
          </el-input>
        </div>
        <!--文字长度限制-->
        <cx-check-box v-if="showAxisLabelLimit" :value.sync="axisLabelLenControl" class="mt16">横轴文字长度限制</cx-check-box>
        <div class="text-limit-box verticallyCenter mt16" v-if="axisLabelLenControl">
          <span>超出</span>
          <el-input type="text" v-model="axisLabelLen" class="text-limit-ipt">
            <template slot="suffix">
              <span class="suffix_text">个</span>
            </template>
          </el-input>
          <span>省略</span>
        </div>
        <!-- 字体和颜色/字重和字号 -->
        <text-setting-update
          class="mt16 mb16"
          colorMode="chart"
          :fontColor.sync="xAxisUnitValueFontColor"
          :fontFamily.sync="xAxisUnitValueFontFamily"
          :fontSize.sync="xAxisUnitValueFontSize"
          :fontWeight.sync="xAxisUnitValueFontWeight"
          v-if="showXAxisUnit"
        />
      </div>
      <div class="mt16" v-if="checkType(xAxisLineType) || checkType(xAxisLineWidth) || checkType(xAxisLabelColor)">
        <!-- <div class="mt16"> -->
        <line-setting
          title="轴线样式"
          :lineName.sync="xAxisLineType"
          :lineWidth.sync="xAxisLineWidth"
          :lineColor.sync="xAxisLabelColor"
        />
      </div>
    </div>
  </div>
</template>

<script>
import publicData from "./publicData"
export default {
  mixins: [publicData],
  props: {
    options: {
      type: Object
    },
    ids: {
      type: Object
    }
  },
  data() {
    return {
      this1: this,
      barColorType: "single",
      hasSplitNumber: 'auto',
      hasMaxMin: 'auto'
    }
  },
  methods: {
    changeColorType(flag) {
      this.barColorType = flag
    },
    checkFormatterValue() {
      if (!this.chartOpt.xAxis.axisLabel.formatter) {
        this.$changeOptionsEV("{value}{valueUnit| }", "chartOption.xAxis.axisLabel.formatter", false)
        this.$changeOptionsEV(
          {
            valueUnit: {
              fontFamily: "sans-serif",
              color: "rgba(255,255,255,1)",
              fontWeight: "400",
              fontSize: 14
            }
          },
          "chartOption.xAxis.axisLabel.rich",
          false
        )
      }
    },
    typeChange() {
      if(this.hasSplitNumber === 'auto'){
        this.splitNumber = 0
      }
    },
    typeChangeMaxMin() {
      if(this.hasMaxMin === 'auto'){
        this.max = 'dataMax'
      }else{
        this.max = 800
      }
    }
  },
  computed: {
    chartOpt() {
      return this.options.chartOption
    },
    xAxisData() {
      return this.hasProperty(this.chartOpt, "xAxis.data")
    },
    splitNumber: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "xAxis.splitNumber", "xAxis.splitNumber", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.xAxis.splitNumber", false)
      }
    },
    min: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "xAxis.min", "xAxis.min", 0)
      },
      set(newVal) {
        if (typeof newVal !== undefined) {
          this.$changeOptionsEV(newVal, "chartOption.xAxis.min", false)
        }
      }
    },
    max: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "xAxis.max", "xAxis.max", 'dataMax')
      },
      set(newVal) {
        if (typeof newVal !== undefined) {
          if(newVal === "dataMax"){
            this.$changeOptionsEV(null, "chartOption.xAxis.max", false)
          }else{
            this.$changeOptionsEV(newVal, "chartOption.xAxis.max", false)
          }
        }
      }
    },
    showXAxisUnitValue: {
      get() {
        return this.chartOpt.xAxis.name
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.xAxis.name", false)
      }
    },
    showXAxisUnit: {
      get() {
        return !!this.chartOpt.xAxis.name?.length
      },
      set(newVal) {
        if (newVal) {
          this.$changeOptionsEV(" ", "chartOption.xAxis.name", false)
        } else {
          this.$changeOptionsEV("", "chartOption.xAxis.name", false)
        }
      }
    },
    xAxisUnitValueFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "xAxis.nameTextStyle.fontFamily", "xAxis.nameTextStyle.fontFamily", "sans-serif")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.xAxis.nameTextStyle.fontFamily", false)
      }
    },
    xAxisUnitValueFontSize: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "xAxis.nameTextStyle.fontSize", "xAxis.nameTextStyle.fontSize", 12)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.xAxis.nameTextStyle.fontSize", false)
      }
    },
    xAxisUnitValueFontWeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "xAxis.nameTextStyle.fontWeight", "xAxis.nameTextStyle.fontWeight", 400)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.xAxis.nameTextStyle.fontWeight", false)
      }
    },
    xAxisUnitValueFontColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "xAxis.nameTextStyle.color", "xAxis.nameTextStyle.color", 'rgba(255,255,255,1)')
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.xAxis.nameTextStyle.color", false)
      }
    },
    showXAxis: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "xAxis.show", "xAxis.show", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.xAxis.show", false)
      }
    },
    axisLabelLen:{
      get() {
        return this.hasProperty(this.chartOpt, "xAxis.axisLabel.axisLabelLen")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.xAxis.axisLabel.axisLabelLen", false)
      }
    },
    showAxisLabelLimit(){
      return this.checkAndSetPrimaryVal(this.chartOpt, "xAxis.axisLabel.axisLabelLen", "xAxis.axisLabel.axisLabelLen", false)
    },
    axisLabelLenControl:{
      get() {
        return this.hasProperty(this.chartOpt, "xAxis.axisLabel.axisLabelLenControl")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.xAxis.axisLabel.axisLabelLenControl", false)
      }
    },
    xAxisFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "xAxis.axisLabel.fontFamily", "xAxis.axisLabel.fontFamily", "sans-serif")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.xAxis.axisLabel.fontFamily", false)
      }
    },
    xAxisFontColor: {
      get() {
        return this.hasProperty(this.chartOpt, "xAxis.axisLabel.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.xAxis.axisLabel.color", false)
      }
    },
    xAxisFontWeight: {
      get() {
        return this.hasProperty(this.chartOpt, "xAxis.axisLabel.fontWeight")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.xAxis.axisLabel.fontWeight", false)
      }
    },
    xAxisFontSize: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "xAxis.axisLabel.fontSize", "xAxis.axisLabel.fontSize", 12)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.xAxis.axisLabel.fontSize", false)
      }
    },
    xAxisLabelColor: {
      get() {
        return this.hasProperty(this.chartOpt, "xAxis.axisLine.lineStyle.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.xAxis.axisLine.lineStyle.color", false)
      }
    },
    xAxisLineType: {
      get() {
        return this.hasProperty(this.chartOpt, "xAxis.axisLine.lineStyle.type")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.xAxis.axisLine.lineStyle.type", false)
      }
    },
    xAxisLineWidth: {
      get() {
        return this.hasProperty(this.chartOpt, "xAxis.axisLine.lineStyle.width")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.xAxis.axisLine.lineStyle.width", false)
      }
    },
    xAxisLabelRotate: {
      get() {
        return this.hasProperty(this.chartOpt, "xAxis.axisLabel.rotate")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.xAxis.axisLabel.rotate", false)
      }
    },
    xAxisLabelInterval: {
      get() {
        return this.hasProperty(this.chartOpt, `xAxis.axisLabel.interval`)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.xAxis.axisLabel.interval", false)
      }
    },
    boundaryGap: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "xAxis.boundaryGap", "xAxis.boundaryGap",  true)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.xAxis.boundaryGap", false)
      }
    }
  },
  mounted() {
    if(this.chartOpt.yAxis?.splitNumber > 0){
      this.hasSplitNumber = 'self'
    }
    if(typeof this.chartOpt?.yAxis?.max !== "undefined" && this.chartOpt.yAxis.max > 0){
      this.hasMaxMin = 'self'
    }
  }
}
</script>

<style scoped>
.number-input-boxAround {
  align-items: normal;
}
::v-deep .el-select {
  margin-bottom: 0px;
}
.bar-options-setting-dialog .tabs-color {
  width: 86px;
  height: 24px;
}
.bar-options-setting-dialog .tabs-color .tabs-color-item {
  padding: 0 8px;
  background: #35383f;
  border-radius: 3px;
  position: static;
  width: 42px;
  height: 22px;
  font-size: 13px;
  line-height: 18px;
  color: #717989;
  cursor: pointer;
}
.bar-options-setting-dialog .tabs-color .tabs-color-item.active {
  background: var(--themeColor);
  color: #ffffff;
}
.text-limit-ipt {
  margin: 0 16px;
  width: 90px;
}
</style>
